import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { AlertCircle, Loader2 } from 'lucide-react';
import './auth.css';

const LoginPage = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            const user = await login(email, password);
            if (user.is_admin) {
                navigate('/admin');
            } else {
                navigate('/');
            }
        } catch (err) {
            setError(err.response?.data?.error || 'Неверный email или пароль');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-screen">
            <div className="auth-wrap">
                <p className="auth-brand">PASSX</p>

                <div className="auth-panel">
                    <header className="auth-head">
                        <h1 className="auth-title">Вход</h1>
                        <p className="auth-lead">Введите email и пароль, чтобы продолжить работу</p>
                    </header>

                    {error && (
                        <div className="auth-alert auth-alert--warn" role="alert" id="login-error">
                            <AlertCircle size={20} aria-hidden="true" />
                            <span>{error}</span>
                        </div>
                    )}

                    <form className="auth-form-body" onSubmit={handleSubmit}>
                        <div className="auth-field">
                            <label className="auth-label" htmlFor="login-email">Email</label>
                            <input
                                id="login-email"
                                className="auth-input"
                                type="email"
                                autoComplete="email"
                                autoCapitalize="none"
                                spellCheck={false}
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                placeholder="email@example.com"
                                aria-invalid={error ? 'true' : undefined}
                                aria-describedby={error ? 'login-error' : undefined}
                            />
                        </div>
                        <div className="auth-field">
                            <label className="auth-label" htmlFor="login-password">Пароль</label>
                            <input
                                id="login-password"
                                className="auth-input"
                                type="password"
                                autoComplete="current-password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                                placeholder="••••••••••••"
                                aria-invalid={error ? 'true' : undefined}
                                aria-describedby={error ? 'login-error' : undefined}
                            />
                            <Link className="auth-link auth-forgot" to="/forgot-password">Забыли пароль?</Link>
                        </div>
                        <button
                            className="auth-submit"
                            type="submit"
                            disabled={loading}
                            aria-busy={loading ? 'true' : undefined}
                        >
                            {loading && <Loader2 size={20} className="auth-spin" aria-hidden="true" />}
                            {loading ? 'Вход...' : 'Войти'}
                        </button>
                    </form>

                    <p className="auth-switch">
                        Нет аккаунта? <Link className="auth-link" to="/register">Запросить доступ</Link>
                    </p>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
